var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPurchaseImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6543 38.5962H23.1543",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4043 32.4951V44.9951",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.65 6.29534L31.575 6.47034L24.325 23.2953H17.2C15.5 23.2953 13.875 23.6453 12.4 24.2703L16.775 13.8203L16.875 13.5703L17.05 13.1703C17.1 13.0203 17.15 12.8703 17.225 12.7453C20.5 5.17034 24.2 3.44534 31.65 6.29534Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.125 23.7954C44 23.4454 42.8 23.2953 41.6 23.2953H24.325L31.575 6.47035L31.65 6.29535C32.025 6.42035 32.375 6.59535 32.75 6.74535L38.275 9.07035C41.35 10.3453 43.5 11.6703 44.8 13.2703C45.05 13.5703 45.25 13.8453 45.425 14.1703C45.65 14.5203 45.825 14.8703 45.925 15.2453C46.025 15.4703 46.1 15.6953 46.15 15.8953C46.825 17.9953 46.425 20.5704 45.125 23.7954Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8043 35.4959V40.3709C53.8043 40.8709 53.7793 41.3709 53.7543 41.8709C53.2793 50.5959 48.4043 54.9959 39.1543 54.9959H19.6543C19.0543 54.9959 18.4543 54.9459 17.8793 54.8709C9.9293 54.3459 5.6793 50.0959 5.1543 42.1459C5.0793 41.5709 5.0293 40.9709 5.0293 40.3709V35.4959C5.0293 30.4709 8.0793 26.1459 12.4293 24.2709C13.9293 23.6459 15.5293 23.2959 17.2293 23.2959H41.6293C42.8543 23.2959 44.0543 23.4709 45.1543 23.7959C50.1293 25.3209 53.8043 29.9709 53.8043 35.4959Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.775 13.8203L12.4 24.2703C8.05 26.1453 5 30.4703 5 35.4953V28.1703C5 21.0703 10.05 15.1453 16.775 13.8203Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7965 28.1691V35.4941C53.7965 29.9941 50.1465 25.3191 45.1465 23.8191C46.4465 20.5691 46.8215 18.0191 46.1965 15.8941C46.1465 15.6691 46.0715 15.4441 45.9715 15.2441C50.6215 17.6441 53.7965 22.5691 53.7965 28.1691Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPurchaseImage);
export default __webpack_public_path__ + "static/media/card-purchase-image.925d6174ca55575fb57306e2513abcb5.svg";
export { ForwardRef as ReactComponent };